import { ContactInfoColumns } from "./contactInfoColumns";

const initialCollectionColumns = [
  { 
    label: "Id:",
    column: "id",
    type: "string",
    showCopyIcon: true
  },
  {
    label: "Identifier:",
    column: "identifier",
    type: "string",
  },
  { 
    label: "Version:",
    column: "version",
    type: "string" 
  },
  {
    label: "Interoperability Tier:",
    column: { interoperabilityLevel: ["label", "ontologyTermURI"] },
    type: "ref",
  },
  {
    label: "Documentation:",
    column: "page",
    type: "hyperlink",
  },
  {
    label: "Theme:",
    column: { theme: ["label", "ontologyTermURI"] },
    type: "ref",
  },
  {
    label: "Health Category:",
    column: { healthCategory: ["label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Health Theme:",
    column: { healthTheme: ["label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Type:",
    column: { type: ["label", "ontologyTermURI"] },
    type: "mref",
    showOnBiobankCard: true,
  },
  {
    label: "Access Rights:",
    column: { accessRights: ["label", "ontologyTermURI"] },
    type: "ref",
  },
  {
    label: "Applicable Legislation:",
    column: "applicableLegislation",
    type: "hyperlink",
  },
  {
    label: "Legal Basis:",
    column: { hasLegalBasis: ["id", "description"] },
    type: "mref",
  },
  {
    label: "Purpose objects:", 
    column: { hasPurpose_obj: ["id", "description"] },
    type: "mref" 
  },
  {
    label: "Purpose IRIs:", 
    column: { hasPurpose_IRI: ["label", "ontologyTermURI"] },
    type: "mref" 
  },
  {
    label: "Personal Data:", 
    column: { hasPersonalData: ["name", "label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Retention Period:",
    column: { retentionPeriod: ["id"] },
    type: "period",
  },
  {
    label: "Publisher:",
    column: { publisher: ["id", "name"] },
    type: "ref",
  },
  {
    label: "Number of Unique Individuals:",
    column: "numberOfUniqueIndividuals",
    type: "int",
  },
  { 
    label: "Number of Imaging Studies:",
    column: "numberOfRecords",
    type: "int"
  },
  {
    label: "Birth Sex:",
    column: { hasBirthSex: ["code", "label", "ontologyTermURI"] },
    type: "mref",
    showOnBiobankCard: true,
  },
  {
    label: "Age:",
    type: "range_median",
    min: "minTypicalAge",
    max: "maxTypicalAge",
    median: "age_median",
    column: ["minTypicalAge", "maxTypicalAge"],
  },
  {
    label: "Cancer Condition:",
    column: { hasCondition: ["name", "label", "ontologyTermURI"] },
    type: "ref",
    showOnBiobankCard: true,
  },
  {
    label: "Population Coverage:",
    column: "populationCoverage",
    type: "string",
  },
  {
    label: "Collection Method:",
    column: { collectionMethod: ["label", "ontologyTermURI"] },
    type: "mref",
    showOnBiobankCard: true,
  },
  {
    label: "Geographical Coverage:",
    column: { spatial: ["label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Image Modality:",
    column: { hasImageModality: ["code", "label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Image Equipment Manufacturer:",
    column: { hasEquipmentManufacturer: ["label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Image Body Part/Structure:",
    column: { hasImageBodyPart: ["code", "label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Image Acquisition Period:",
    column: { temporal: ["id"] },
    type: "period",
  },
  {
    label: "Segmentation Label:",
    column: { hasAnnotationLabel: ["name", "label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Segmentation Method:",
    column: { hasAlgorithmType: ["name", "label", "ontologyTermURI"] },
    type: "mref",
  },
  { 
    label: "Number of Segmentations:",
    column: "nbrOfSegmentations",
    type: "int"
  },
  {
    label: "Keyword:",
    column: "keyword",
    type: "array",
  },
  {
    label: "Provenance:",
    column: { provenance: ["id", "label"] },
    type: "mref",
  },
  {
    label: "Coding System:",
    column: { hasCodingSystem: ["name", "label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Code Values:",
    column: "hasCodeValues",
    type: "hyperlink",
  },
  {
    label: "Was Generated By:",
    column: "wasGeneratedBy",
    type: "hyperlink",
  },
  {
    label: "Conforms To:",
    column: "conformsTo",
    type: "hyperlink",
  },
  {
    label: "Creator:", 
    column: { creator: ["id", "name"] },
    type: "mref",
  },
  {
    label: "Release Date:",
    column: "issued",
    type: "date",
  },
  { 
    label: "Modification Date:",
    column: "modified",
    type: "date",
  },
  {
    label: "Version Notes:",
    column: "versionNotes",
    type: "array",
  },
  {
    label: "Other Identifier:",
    column: { other_identifier: ["notation", "schemaAgency"] },
    type: "mref"
  },
  {
    label: "Language:",
    column: { language: ["name", "label", "ontologyTermURI"] },
    type: "mref",
  },
  {
    label: "Frequency:", 
    column: { accrualPeriodicity: ["name", "label", "ontologyTermURI"] },
    type: "ref",
  },
  {
    label: "Landing Page:",
    column: "landingPage",
    type: "hyperlink",
  },
  {
    label: "Is Referenced By:",
    column: "isReferencedBy",
    type: "hyperlink",
  },
  {
    label: "Spatial Resolution:",
    column: "spatialResolutionInMeters",
    type: "string",
  },
  {
    label: "Temporal Resolution:",
    column: "temporalResolution",
    type: "string",
  },
  {
    label: "Related Resource:",
    column: "relation",
    type: "hyperlink",
  },
  {
    label: "Qualified Attribution:",
    column: {
      qualifiedAttribution: [{ agent: ["name"] }],
    },
    type: "nested_ref",
  },
  {
    column: [
      "title",
      "description",
      "in_series.id",
      "in_series.title",
      "in_series.pid",
      "in_series.contactPoint.hasEmail",
      "sample.id",
      "analytics.id",
      ...ContactInfoColumns,
    ],
  },
];

export default initialCollectionColumns;
